module.exports = __webpack_public_path__ + "static/media/Landing_page_Banner_Tablet@1x.62b864bd.jpg";